// extracted by mini-css-extract-plugin
export default {"container":"question-status_container__1JeN9","label":"question-status_label__2ZIfI","withPill":"question-status_withPill__3g3IQ"};